// extracted by mini-css-extract-plugin
export var container = "bento-block-module--container--44c08";
export var content = "bento-block-module--content--6cb7f";
export var row = "bento-block-module--row--8eecf";